import { GetStaticPropsResult } from 'next'

import { SanitySiteFragment } from '@data/sanity/queries/types/site'
import { SanityCartPage } from '@data/sanity/queries/types/page'
import { getShopifyDomain } from '@lib/shopify/client'
import { getPreview } from '@lib/sanity/client'
import { getCartPage } from '@lib/sanity/page'
import { Locale } from '@lib/language'
import { getReviews, Reviews } from '@lib/review'
import { CustomStaticPropsContext } from '@lib/routes'

import Layout from '@components/layout'
import Modules from '@modules/modules'

interface CartProps {
  locale: Locale
  page: SanityCartPage
  site: SanitySiteFragment
  reviews?: Reviews
}

const Cart = ({ page, site, reviews }: CartProps) => (
  <Layout page={page} site={site}>
    <Modules modules={page.modules} reviews={reviews} />
  </Layout>
)

export async function getStaticProps({
  locale,
  preview,
  previewData,
}: CustomStaticPropsContext): Promise<GetStaticPropsResult<CartProps>> {
  const cartPage = await getCartPage(locale, getPreview(preview, previewData))

  if (!cartPage.page) {
    return { notFound: true }
  }

  // Get Stamped.io reviews
  const shopifyDomain = getShopifyDomain(locale)
  const reviews = await getReviews(
    cartPage.page.modules ?? [],
    shopifyDomain,
    cartPage.site.settings.stampedApiKey
  )

  return {
    props: {
      locale,
      page: cartPage.page,
      site: cartPage.site,
      reviews,
    },
    revalidate: 60,
  }
}

export default Cart
